import Comp from "./Tutorial";

export default Comp;
